module.exports = __webpack_public_path__ + "static/media/extra-ad.e51f4223.svg";